import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-chatbot-kit/build/main.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import FeatureRequest from "./pages/solutions/FeatureRequest";
import Feature from "./pages/features/index";
import PricingPage from "./pages/pricing/index";
import PrivacyPolicy from "./pages/privacypolicy/index";
import ReleaseNote from "./pages/releasenote/index";
import UpdateInfomation from "./pages/releasenote/ReleaseNoteDetails";
import Blog from "./pages/blog/index";
import BlogInfomation from "./pages/blog/BlogDetails";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/notfound/Index";
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";
import Termsofserice from "./pages/termsofservice/index";
import AboutUs from "./pages/aboutus/Index";
import TeacherRewardsPage from "./pages/teacher-rewards/index";
import TeacherRewardTermsPage from "./pages/teacher-rewards-terms/index";
import SchoolRewardPage from "./pages/school-reward/index";
import WebChat from "../src/components/WebChat";

function MarketingSiteShell() {
  const { pathname } = useLocation();
  const normalized = pathname.replace(/\/$/, "") || "/";
  const hideFooter = normalized === "/teacher-rewards" || normalized === "/school-reward";

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route index element={<App />} />
        <Route path="/feature-request" element={<FeatureRequest />} />
        <Route path="/feature" element={<Feature />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/termsofservice" element={<Termsofserice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/product-update" element={<ReleaseNote />} />
        <Route path="/product-update/:slug/:id" element={<UpdateInfomation />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug/:id" element={<BlogInfomation />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/teacher-rewards" element={<TeacherRewardsPage />} />
        <Route path="/teacher-rewards/terms-and-conditions" element={<TeacherRewardTermsPage />} />
        <Route path="/school-reward" element={<SchoolRewardPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <WebChat />
      {!hideFooter && <Footer />}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MarketingSiteShell />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
